import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from 'axios'
import Buefy from 'buefy'
import mixins from './mixins'
import '@/styles/styles.scss'
import IdleVue from 'idle-vue'
Vue.use(Buefy)

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 60000 // idle for 1 min
})

Vue.prototype.$http = axios

Vue.config.productionTip = false

// global variable
Vue.mixin(mixins)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
